import { css } from '@emotion/core'
import { FloatingBottom, SafeAreaConstantPadding, SafeAreaEnvPadding } from '@styles/base.style'
import styled, { Theme } from '@themes/theme'

export const MenuTopItem = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 60px 33px 42px;
  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 273px;
    background: ${props => props.theme.color.mainBg};
  }
  .my-info-btn {
    display: flex;
    align-items: center;
    .profile-img {
      position: relative;
      display: block;
      width: 54px;
      height: 54px;
      border-radius: 50%;
      overflow: hidden;
      background: #eee;
      margin-right: 12px;
      &.custom {
        background: none;
      }
      img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: auto;
        &.custom-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
    .user-info {
      display: flex;
      flex-flow: column;
      text-align: left;
      .nickname {
        line-height: 2.7rem;
        font-size: ${props => props.theme.font.title};
        font-weight: ${props => props.theme.fontW.medium};
      }
      .more-info {
        line-height: 1.8rem;
        color: ${props => props.theme.color.disableTxt};
        font-weight: ${props => props.theme.fontW.medium};
        .arrow-ico {
          position: relative;
          display: inline-block;
          width: 7px;
          height: 7px;
          transform: rotate(-45deg) translateY(-1px);
          margin-left: 2px;
          &::before, &::after {
            content: '';
            display: block;
            position: absolute;
            bottom: 0;
            right: 0;
            background: ${props => props.theme.color.disableTxt};
          }
          &::before {
            width: 100%;
            height: 1px;
          }
          &::after {
            width: 1px;
            height: 100%;
          }
        }
      }
    }
  }
  .charge-btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    transform: translateY(-1px);
    width: 63px;
    height: 33px;
    box-shadow: 2px 2px 2px #171a24;
    img {
      width: inherit;
      height: auto;
    }
  }
  .pc-btn-wrap {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 63px;
    min-width: 63px;
  }
`

export const DrawerWrap = (theme: Theme) => css`
  .ant-drawer-close {
    color: ${theme.color.modalgray};
  }
  /* PC */
  z-index: 3 !important;
  position: absolute !important;
  .ant-layout-sider-light,
  .ant-drawer-body,
  .css-1vwmjlj-Sider {
    background: ${theme.color.TP};
  }
  .ant-drawer-content-wrapper {
    width: 100% !important;
  }
  .ant-drawer-body {
    height: 100%;
    max-height: 100vh;
    padding: 0;
    overflow: hidden;
  }
  .ant-layout-sider {
    z-index: 10;
    width: 100%;
    height: calc(100% - 97px);
    overflow: hidden;
  }
  .ant-layout-sider-children {
    display: flex;
    flex-direction: column;
    /* justify-content: space-between; */ /* 전용클럽 -> 메뉴 리스트가 줄었을 때 상단 여백 생기는 문제 해결 */
  }
  .ant-divider,
  .ant-divider-horizontal,
  .ant-divider-with-text-left {
    margin: 10px 0;
  }
`
export const SiderStyle = (theme: Theme) => css`
  height: 100%;
  .ant-menu-root.ant-menu-vertical,
  .ant-menu-root.ant-menu-vertical-left,
  .ant-menu-root.ant-menu-vertical-right,
  .ant-menu-root.ant-menu-inline {
    width: 100% !important;
  }
  .ant-layout-sider-children {
    display: flex;
    flex-flow: column;
    justify-content: space-between;
  }
  .bottom {
    display: flex;
    flex-flow: column;
    align-items: flex-start;
    justify-content: flex-end;
    padding-left: 18px;
    padding-right: 18px;
    padding-bottom: ${SafeAreaEnvPadding};
    padding-bottom: ${SafeAreaConstantPadding};
    gap: 6px;
  }
  &, .bottom {
    background: ${theme.color.themeTxt};
  }
`
export const TitTxt = css({
  position: 'absolute',
  left: '50%',
  top: '50%',
  width: '100%',
  margin: 0,
  fontWeight: 500,
  textAlign: 'center',
  transform: 'translate(-50%, -80%)',
})

export const MemberType = css({
  position: 'absolute',
  left: 0,
  top: 0,
  color: '#838383',
})

export const Brand = (theme: Theme) => css`
  position: relative;
  z-index: 1;
  align-items: center;
  justify-content: center;
  height: 55px;
  padding: 25px 0 0;
  background: ${theme.color.modalBg};
`
export const Guest = (theme: Theme) =>
  css`
    position: relative;
    z-index: 1;
    align-items: center;
    justify-content: center;
    padding: 25px 10px 0;
    background: ${theme.color.modalBg};
    height: 200px;
    .ant-btn {
      position: absolute;
      top: 0;
      right: 0;
      width: 40px;
      height: 40px;
      background: ${theme.color.TP};
      box-shadow: none;
      &::before {
        position: absolute;
        top: 16.5px;
        left: 15px;
        display: block;
        width: 20px;
        height: 20px;
        background: ${theme.color.TP};
        border-left: 2px solid rgb(77, 77, 77);
        border-radius: 0;
        transform: rotate(45deg);
        opacity: 1;
        content: '';
      }
      &::after {
        position: absolute;
        top: 3.5px;
        right: 5px;
        display: block;
        width: 20px;
        height: 20px;
        background: ${theme.color.TP};
        border-left: 2px solid rgb(77, 77, 77);
        transform: rotate(-45deg);
        opacity: 1;
        content: '';
      }
    }
  `
export const CloseBtn = (theme: Theme) =>
  css`
    position: absolute;
    top: 0;
    right: -25px;
    width: 40px;
    height: 40px;
    overflow: hidden;
    background: ${theme.color.TP};
    border: none;
    box-shadow: none;
    &::before {
      position: absolute;
      top: 16.5px;
      left: 15px;
      display: block;
      width: 20px;
      height: 20px;
      background: ${theme.color.TP};
      border: none;
      border-left: 2px solid ${theme.color.themeTxt};
      border-radius: 0;
      transform: rotate(45deg);
      opacity: 1;
      animation: none;
      content: '';
    }
    &::after {
      position: absolute;
      top: 3.5px;
      right: 5px;
      display: block;
      width: 20px;
      height: 20px;
      background: ${theme.color.TP};
      border-left: 2px solid ${theme.color.themeTxt};
      transform: rotate(-45deg);
      opacity: 1;
      content: '';
    }
  `
export const CloseBtnTxt = css({
  position: 'absolute',
  lineHeight: '9999',
})
export const UserName = (theme: Theme) =>
  css`
    display: inline-block;
    margin: 0;
    margin-right: 5px;
    color: ${theme.color.modalSubTxt};
    font-size: ${theme.font.title};
  `
export const UserType = (theme: Theme) =>
  css`
    color: ${theme.color.modalred};
  `
export const LoginWrap = css({
  position: 'relative',
  height: '170px',
})

export const LoginBtn = (theme: Theme) =>
  css`
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 30px;
    color: ${theme.color.themeTxt};
    border-radius: 50px;
  `

export const MoneyStyle = styled.span`
  position: relative;
  float: right;
  top: 2px;
  width: 14px;
  margin-left: 3px;
  &::after {
    content: '';
    display: block;
    clear: both;
  }
`
export const UserBtn = css`
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  margin: 5px 0;
`
export const UserSideBtn = css`
  width: 51px;
  height: auto;
  margin-left: 7px;
  img {
    width: 100%;
    height: auto;
    transform: translate3d(0, 0, 0);
  }
`
export const MenuContainer = (theme: Theme) =>
  css`
    flex: 1;
    height: auto;
    overflow-x: hidden;
  `
export const MoneyWrap = (theme: Theme) => css`
  position: relative;
  overflow: hidden;
`
export const MoneyRow = (theme: Theme) => css`
  height: 32px;
  padding: 0 10px !important;
  line-height: 3.2rem;
  background-color: ${theme.color.modalSubBg2};
  border-radius: 8px;
  &.g-money {
    border-radius: 8px 8px 0 0;
    &::before {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      left: 50%;
      width: 92%;
      border-bottom: 1px solid ${theme.color.modalBg};
      transform: translate(-50%, 0);
    }
  }
  &.heart {
    border-radius: 0;
    &::before {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      left: 50%;
      width: 92%;
      border-bottom: 1px solid ${theme.color.modalBg};
      transform: translate(-50%, 0);
    }
  }
  &.dia {
    border-radius: 0 0 8px 8px;
  }
  &.s-cash {
    margin: 6px 0;
  }
  &.coupon {
    .bet-coupon-img {
      position: relative;
      float: left;
      top: 4px;
      width: 25px;
      &::after {
        content: '';
        display: block;
        clear: both;
      }
      & + span {
        float: left;
        margin-left: 10px;
        color: ${theme.color.modalSubTxt};
      }
    }
    .money-row {
      position: absolute;
      right: 27px;
      color: ${theme.color.modalTxt};
    }
    /* tooltip btn  */
    .tooltip-btn {
      float: right;
      margin-right: -10px;
      svg {
        margin-left: 3px;
      }
    }
  }
  .txt {
    z-index: 1;
    position: relative;
    color: ${theme.color.modalSubTxt};
  }
  &.left-padding {
    padding-left: 5px;
  }
`
export const ColStyle = css`
  border: 1px solid blue;
`
export const MoneyRowWrap = (theme: Theme) =>
  css`
    float: right;
  `
export const MoneyRowWrapNum = styled.span`
  font-size: ${props => props.theme.font.large};
  color: ${props => props.theme.color.modalTxt};
`

// 서랍메뉴 하단 버튼
export const SubBtnWrapStyle = (theme: Theme) => css`
  position: relative;
  display: flex;
  width: 100%;
  padding: 0 20px;
  background: ${theme.color.modalBg};
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  transition: all 0.3s;
  .sns-btn-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 120px;
    &--btn {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background: none;
      img {
        width: 100%;
        height: auto;
      }
    }
    &.pc {
      width: 126px;
    }
  }
  .line {
    width: 1px;
    height: 12px;
    background: ${theme.color.modalDarkBg};
  }
  .setting-btn-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 146px;
    &--btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 67px;
      height: 32px;
      border-radius: 50px;
      background: ${theme.color.modalBlue};
      &--ico, & > svg {
        width: 17px;
        height: auto;
        margin-right: 6px;
      }
      &--ico {
        transform: translateY(-4%);
      }
      & > svg {
        position: relative;
        top: -1px;
      }
    }
    &.pc {
      width: 179px;
      .setting-btn-wrap--btn {
        width: 82px;
      }
    }
  }
`
// 전용클럽일 때 서랍메뉴 하단 버튼 스타일
export const SpecificClubMemberSubBtnStyle = (theme: Theme) => css`
  width: 100%;
  height: 32px;
  line-height: 3.2rem;
  text-align: center;
  background-color: ${theme.color.modalBlue};
  border: none;
  border-radius: 50px;
  svg {
    position: relative;
    top: -1px;
    width: 15px;
    height: auto;
    margin-right: 4px;
  }
  &.telegram {
    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 32px;
    }
  }
  &.setting-btn {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`
export const MenuItemContainer = styled.div`
  position: relative;
  height: auto;
  padding: 0 18px;
  transition: all 0.3s;
`
export const MenuItemWrap = styled.div`
  position: relative;
  .ant-menu-inline,
  .ant-menu-vertical,
  .ant-menu-vertical-left {
    border: none;
  }
  .ant-menu {
    display: flex;
    flex-wrap: wrap;
    background: transparent !important;
    gap: 12px 0;
    .ant-menu-item {
      display: inline-flex;
      flex-flow: column;
      justify-content: center;
      align-items: center;
      width: 25%;
      height: auto;
      min-height: 75px;
      padding: 0 !important; /* antd에서 inline style로 적용된 padding값이 있어 !important 사용 */
      margin: 0;
      text-align: center;
      line-height: 2.5rem;
      transition: all .3s;
      overflow: visible;
      &:first-of-type, &:nth-of-type(2), &:nth-of-type(3), &:nth-of-type(4) {
        margin: 0 0 53px;
        svg {
          margin-bottom: 24px;
        }
        .menu-ico-img-wrap {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 42px;
          height: 42px;
          margin-bottom: 14px;
          border-radius: 50%;
          background: ${props => props.theme.color.themeTxt};
          box-shadow: -2px -2px 3px #454A58, 3px 3px 3px #141414;
        }
        .menu-ico-img {
          position: relative;
          width: 30px;
          height: 30px;
        }
        p {
          color: ${props => props.theme.color.themeTxt};
        }
      }
      &::after {
        display: none;
      }
      p {
        font-size: ${props => props.theme.font.medium};
        font-weight: ${props => props.theme.fontW.medium};
        color: ${props => props.theme.color.mainBg};
      }
      .sider-notice-badge {
        position: absolute;
        top: -4px;
        right: 19px;
        width: 6px;
        height: 6px;
      }
    }
    .ant-menu-item-active {
      background: ${props => props.theme.color.TP} !important;
      p, path:not(.none), .fill {
        color: ${props => props.theme.color.disableTxt};
        fill: ${props => props.theme.color.disableTxt};
      }
    }
    .ant-menu-item-selected {
      background: ${props => props.theme.color.TP} !important;
      p, path:not(.none), .fill {
        color: ${props => props.theme.color.mainBg};
        fill: ${props => props.theme.color.mainBg};
      }
    }
  }
`
export const IconStyle = css`
  svg {
    position: relative;
    width: 22px;
    height: 22px;
    margin-bottom: 6px;
    path, .fill {
      fill: #1c202b;
    }
  }
`
export const GiftBoxBtn = (theme: Theme) => css`
  position: absolute;
  bottom: ${FloatingBottom};
  right: 18px;
  width: 45px;
  height: auto;
  min-height: 45px;
  border-radius: 50%;
  padding-bottom: ${SafeAreaEnvPadding};
  padding-bottom: ${SafeAreaConstantPadding};
  .btn-bg {
    position: relative;
    width: inherit;
    height: 45px;
    border-radius: 50%;
    &::before {
      content: '';
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      width: inherit;
      height: inherit;
      transform: translate(-50%, -50%);
      background: ${theme.color.modalBg};
      border-radius: 50%;
    }
    svg {
      width: 27px;
      transform: translateY(10px);
    }
    .gift-box-txt {
      position: absolute;
      bottom: -2px;
      left: 50%;
      transform: translateX(-50%) scale(1.1);
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: 39px;
      height: 17px;
      border-radius: 50px;
      color: ${theme.color.themeTxt};
      font-size: ${theme.font.tiny};
      font-weight: ${theme.fontW.bold};
      background: ${theme.color.modalyellow};
      &.opened {
        background: ${theme.color.modalDarkBg};
      }
    }
  }
  .sider-badge {
    position: absolute;
    top: 7px;
    left: 50%;
    transform: translate(100%, 0);
    display: flex;
  }
  &.pc-sider-gift-box {
    position: relative;
    bottom: initial;
    right: initial;
    width: auto;
    height: 33px;
    min-height: initial;
    border-radius: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 12px;
    background: rgba(80, 96, 112, .2);
    svg {
      width: 18px;
    }
    .gift-box-txt {
      width: auto;
      position: relative;
      background: none;
      transform: none;
      bottom: initial;
      left: initial;
      font-size: ${theme.font.medium};
    }
    .sider-badge {
      top: 3px;
      left: initial;
      right: 8px;
    }
  }
  .guide-txt-img {
    position: absolute;
    top: 50%;
    left: 0;
    width: auto;
    height: 26px;
    transform: translate(-135px, -50%);
  }
`
export const GuideSiderBtnStlye = css`
  width: auto;
  height: auto;
  border-radius: 0;
  img {
    width: auto;
    height: 54px;
    box-shadow: 0 1px 3px rgba(0, 0, 65, .6);
    border-radius: 8px;
  }

`

export const UsageGuideVideoSiderBtnStyle = (theme: Theme) => css`
  width: fit-content;
  height: 53px;
  border-radius: 8px;
  box-shadow: rgba(0, 42, 65, 0.4) 0px 1px 3px;
  overflow: hidden;
  
  img {
    width: auto;
    height: 53px;
    object-fit: contain;
  }
`
